<template>
  <div class="special-sale-nav" ref="specialSalelNav">
    <van-tabs
      :background="transBg"
      :border="false"
      :ellipsis="false"
      :lazy-render="true"
      :offset-top="navHeight"
      :sticky="true"
      :style="{ minHeight: clientHeight + 'px' }"
      @change="switchTab"
      @scroll="scrollHandler"
      class="special-sale-tabs"
      color="#fff"
      title-active-color="#fff"
      title-inactive-color="#fff"
      v-model="current"
    >
      <van-tab
        :key="index"
        :title="tabName.name"
        class="tab-item"
        v-for="(tabName, index) in navList"
      >
        <div class="container">
          <div class="product-lists" v-show="index === current">
            <div class="tab-content">
              <van-list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
                <div class="product-list">
                  <cont-item :banner="navItemBanner" :sku-list="contList" />
                </div>
              </van-list>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs, List } from 'vant'
import ContItem from './SpecialSaleItem'
import api from '../../utils/api'
let flag = false
let timer = null
export default {
  name: 'specialSalelNav',
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    VanList: List,
    ContItem
  },
  props: {
    navList: {
      type: Array
    },
    navHeight: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      navTab: {
        lineColor: '#fff',
        fontColor: '#fff'
      },
      clientHeight: 0,
      current: 0,
      loading: false,
      finished: false,
      contList: [],
      noData: false,
      transBg: 'transparent'
    }
  },
  computed: {
    navItemBanner () {
      return this.navList.length && this.navList[this.current].img_url
    }
  },
  watch: {
    current (newVal) {
      this.contList = []
      this.catPriceList = []
      this.finished = false
      clearTimeout(timer)
      timer = setTimeout(() => {
        this.getGoodsListHandler(this.navList[this.current].id)
      }, 150)
    }
  },
  mounted () {
    this.clientHeight = document.documentElement.clientHeight
  },
  methods: {
    /**
     * 分页加载
     */
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {

      }, 150)
    },
    scrollHandler (i) {
      if (i.scrollTop > 0) {
        if (this.transBg !== 'transparent') {
          return false
        }
        this.transBg = '-webkit-linear-gradient(276deg, #f74d44 30%, #ff8c74 100%)'
      } else {
        this.transBg = 'transparent'
      }
    },
    /**
     * 导航切换
     */
    switchTab (i) {
      // this.navItemBanner = this.navList[this.current].img_url
      // this.$toast.loading()
    },

    /**
     *获取列表封装
     */
    async getGoodsListHandler (id) {
      const data = await api.getActGoodsList(id)
      if (data.length) {
        this.contList = data
      } else {
        this.noData = true
      }
      this.finished = true
    }

  }
}
</script>
<style lang="less">
.special-sale-tabs {
  .van-tabs__wrap {
    padding-bottom: 0.1rem;
  }
  .vant-tab,
  .van-tab--active {
    font-size: 0.26rem !important;
    font-weight: bold !important;
  }
}
</style>
<style lang="less" scoped>
.container {
  padding: 0 0.2rem;
}
</style>
